// payment-page.component.ts
import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OrderService } from "@gloria-public/order/domain/services/order.service";
import { STRIPE_LOADER, StripeLoader } from "@gloria-public/order/domain/token/stripe-loader.token";
import { TranslateService } from "@ngx-translate/core";
import { ConfigService } from "@shared/services/config.service";
import { StripeEmbeddedCheckout } from "@stripe/stripe-js";
import { first } from "rxjs";

@Component({
  selector: "app-payment-page",
  templateUrl: "./payment-page.component.html",
  styleUrls: ["./payment-page.component.scss"],
})
export class PaymentPageComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("checkoutContainer") checkoutContainer!: ElementRef<HTMLDivElement>;

  private clientSecret!: string;
  private secretReady = false;
  private checkout?: StripeEmbeddedCheckout;

  constructor(
    private orderService: OrderService,
    private translateService: TranslateService,
    private router: Router,
    private configService: ConfigService,
    public snackBar: MatSnackBar,
    @Inject(STRIPE_LOADER) private stripeLoader: StripeLoader
  ) {}

  ngOnInit(): void {
    this.orderService
      .addOrder()
      .pipe(first())
      .subscribe({
        next: (clientSecret: string) => {
          this.clientSecret = clientSecret;
          this.secretReady = true;
          this.tryInitStripe();
        },
        error: () => {
          this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", {
            duration: 5000,
          });
          this.router.navigate(["cart/checkout"]);
        },
      });
  }

  ngAfterViewInit(): void {
    this.tryInitStripe();
  }

  private async tryInitStripe(): Promise<void> {
    if (!this.secretReady) return;

    const stripe = await this.stripeLoader(this.configService.stripePublishableKey);

    if (!stripe) {
      this.snackBar.open(`❗ ${this.translateService.instant("common.error")}`, "OK", {
        duration: 5000,
      });
      this.router.navigate(["cart/checkout"]);
      return;
    }

    this.checkout = await stripe.createEmbeddedCheckoutPage({
      fetchClientSecret: async () => this.clientSecret,
    });

    this.checkout.mount(this.checkoutContainer.nativeElement);
  }

  ngOnDestroy(): void {
    this.checkout?.destroy();
  }
}
